import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { query } from "scmp-app/components/article/article-render/series-article";
import { ContentItemSeriesOtherScmpSeries } from "scmp-app/components/content/content-item-render/variants/series-other-scmp-series";
import type { otherScmpSeriesSeriesArticleQueue$key } from "scmp-app/queries/__generated__/otherScmpSeriesSeriesArticleQueue.graphql";
import type { seriesArticleQuery } from "scmp-app/queries/__generated__/seriesArticleQuery.graphql";

import {
  Container,
  List,
  StyledArrowNext,
  StyledArrowPrevious,
  StyledBaseLink,
  StyledSwiper,
  StyledSwiperSlide,
  SwiperWrapper,
  Title,
} from "./styles";

export type Props = {
  className?: string;
  queryReference: PreloadedQuery<seriesArticleQuery>;
};

export const SeriesArticleOtherScmpSeries: FunctionComponent<Props> = ({
  className,
  queryReference,
}) => {
  const data = usePreloadedQuery<seriesArticleQuery>(query, queryReference);

  const queue = useFragment<otherScmpSeriesSeriesArticleQueue$key>(
    graphql`
      fragment otherScmpSeriesSeriesArticleQueue on Queue
      @argumentDefinitions(excludeEntityIds: { type: "[String]" }) {
        items(first: 4, exclude: { entityIds: $excludeEntityIds }) {
          edges {
            node {
              ... on Content {
                ...seriesOtherScmpSeriesContent
              }
            }
          }
        }
      }
    `,
    data.queue ?? null,
  );

  const items = queue?.items?.edges ?? [];
  if (items.length === 0) return null;

  return (
    <Container className={className}>
      <Title>Other SCMP Series</Title>
      <StyledBaseLink as="/series" pathname="/series">
        View all series
      </StyledBaseLink>
      <List>
        <SwiperWrapper>
          <StyledSwiper
            cssMode={false}
            freeMode
            navigation={{
              disabledClass: "other-scmp-swiper-button-disabled",
              nextEl: ".other-scmp-swiper-button-next",
              prevEl: ".other-scmp-swiper-button-prev",
            }}
            pagination={false}
            slidesPerView="auto"
            spaceBetween={8}
          >
            {items.map(({ node }, index) => (
              <StyledSwiperSlide key={index}>
                <ContentItemSeriesOtherScmpSeries reference={node} />
              </StyledSwiperSlide>
            ))}
          </StyledSwiper>
          <div className="swiper-button other-scmp-swiper-button-prev">
            <StyledArrowPrevious />
          </div>
          <div className="swiper-button other-scmp-swiper-button-next">
            <StyledArrowNext />
          </div>
        </SwiperWrapper>
      </List>
    </Container>
  );
};

SeriesArticleOtherScmpSeries.displayName = "SeriesArticleOtherScmpSeries";
